module.exports = __webpack_public_path__ + "img/S-WEB-Goal-13.4fde52d6.png";